/* Custom Collection List */
var swiper = new Swiper(".coll-lists.swiper", {
    slidesPerView: 1.2,
    spaceBetween: 20,
    scrollbar: {   // Ensure scrollbar is enabled
        el: ".swiper-scrollbar",
        draggable: true,  // Allows dragging the scrollbar
      hide: false,
    },
    breakpoints: {
      448: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1199: {
        slidesPerView: 4,
        spaceBetween: 25,
      },
    },
});

/* Custom Review Section */

var swiper = new Swiper(".review-colls.swiper", {
    slidesPerView: 1,
    spaceBetween: 23,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      575: {
        slidesPerView: 1.2,
        spaceBetween: 23,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1400: {
        slidesPerView: 2,
        spaceBetween: 70,
      },
    },
});

/* Text Video Section */

// var swiper = new Swiper(".txt-img-con.swiper", {
//     slidesPerView: 1,
//     spaceBetween: 0,
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
// });


/* Form Do not allwo copy and paste */

document.querySelectorAll("form").forEach(form => {
    form.addEventListener("copy", function(event) {
        event.preventDefault();
    });
    form.addEventListener("paste", function(event) {
        event.preventDefault();
    });
});

// Prevent cut, copy, and paste on input and textarea fields
document.querySelectorAll("input, textarea").forEach((element) => {
    element.addEventListener("cut", (event) => event.preventDefault());
    element.addEventListener("copy", (event) => event.preventDefault());
    element.addEventListener("paste", (event) => event.preventDefault());
});

// Prevent drag and drop on form input and textarea fields
document.querySelectorAll("form input, form textarea").forEach((element) => {
    element.addEventListener("dragenter", (event) => event.preventDefault());
    element.addEventListener("dragover", (event) => event.preventDefault());
    element.addEventListener("drop", (event) => event.preventDefault());
});

// Disable autocomplete and prevent autofill on input, textarea, and select fields
document.querySelectorAll("form input, form textarea, form select").forEach((element) => {
    element.setAttribute("autocomplete", "off");
    // element.setAttribute("readonly", "true");

    element.addEventListener("focus", function () {
        // this.removeAttribute("readonly");
    });
});



/* Related Products */
(function initializeSwiper() {
  // Function to initialize Swiper
  function createSwiper() {
    const swiperContainer = document.querySelector('.related-prodcuts-lists');
    if (swiperContainer) {
      new Swiper(swiperContainer, {
        slidesPerView: 1.5,
        spaceBetween: 20,
        grabCursor: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
          draggable: true,
        },
        breakpoints: {
          575: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 28,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 28,
          },
        },
      });
    }
  }

  // Check if the swiper container exists and initialize
  const swiperContainer = document.querySelector('.related-prodcuts-lists');
  if (swiperContainer) {
    createSwiper();
  } else {
    // If the swiper container is not found, use MutationObserver to wait for it
    const observer = new MutationObserver((mutationsList, observer) => {
      // Only observe for addition of the target element
      if (document.querySelector('.related-prodcuts-lists')) {
        createSwiper(); // Initialize Swiper
        observer.disconnect(); // Stop observing once it's initialized
      }
    });

    // Observe the body or a more specific parent element for changes (target more specific container if possible)
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();


// popup jsvascrip
  document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("discount-popup");
    const closeBtn = document.querySelector(".popup-close-btn");
    const claimBtn = document.querySelector(".claim-discount-btn");
    const popupContent = document.querySelector(".popup-content");
    const body = document.body;

    function openPopup() {
      popup.style.display = "flex";
      body.classList.add("overflow-hidden");
    }

    function closePopup() {
      popup.style.display = "none";
      body.classList.remove("overflow-hidden");
      localStorage.setItem("discount_popup_shown", "true");
    }

    // Show popup on first visit
    if (!localStorage.getItem("discount_popup_shown")) {
      openPopup();
    }

    // Close on button clicks
    closeBtn.addEventListener("click", closePopup);
    claimBtn.addEventListener("click", closePopup);

    // Close on click outside the popup content
    popup.addEventListener("click", function (e) {
      if (!popupContent.contains(e.target)) {
        closePopup();
      }
    });
  });





